import { createContext, ReactNode } from 'react';
import { actionArgs } from './authorized.action';

type authContext = ((args: actionArgs, message?: ReactNode) => void);

export default createContext<authContext>(()=>{ console.log("authorized context is not initialized yet")});